"use strict";

const INVOICE_SUBJECT_MAX_LENGTH = 200;
const isValidInvoiceSubjectFlag = value =>
  [true, false, 1, 0, "1", "0", "true", "false"].includes(value);

function isInvoiceSubjectEnabled(setting) {
  const value = setting && typeof setting === "object" ? setting.invoice_subject_enabled : setting;
  return value === true || value === 1 || value === "1" || value === "true";
}

// Shared display normalization only: validation must reject excessive text,
// rather than silently truncating an object accepted on a saved invoice.
function normalizeInvoiceSubject(value) {
  if (typeof value !== "string") return null;
  return value.normalize("NFC").replace(/[\u0000-\u001f\u007f\s]+/g, " ").trim() || null;
}

module.exports = {
  INVOICE_SUBJECT_MAX_LENGTH,
  isValidInvoiceSubjectFlag,
  isInvoiceSubjectEnabled,
  normalizeInvoiceSubject,
};
